import { useQuery } from '@apollo/client';
import { Close } from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/Done';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FeedItem from 'component/feed_item';
import BottomShareModal from 'component/share/share_bottom_modal';
import StandardPopup from 'component/StandardPopup';
import { ItemStatus } from 'containers/style_detail/constant';
import { GET_REACTION_INFORMATION } from 'graph_ql/reaction/queries';
import millify from 'millify';
import { MouseEventHandler, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'redux/store';
import themes from 'styles/themes';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import { fetchImageForShare, nativeImageShare } from 'utils/share';
import styleItemUtils from 'utils/style_item';
import { useVisualViewport } from 'utils/useVisaulViewport';
import utils, { renderTitleWarningEditStyle } from 'utils/utils';
import { ReactComponent as DislikeFill } from '../../assets/svg/disliked_old.svg';
import { ReactComponent as EditStyle } from '../../assets/svg/edit_style.svg';
import { ReactComponent as BtnLikeFill } from '../../assets/svg/like_fill_v2.svg';
import { ReactComponent as BtnShare } from '../../assets/svg/share_v2.svg';
import { STRINGS } from '../../constants';
import { useStyles } from './style';
import { ReactComponent as FeedBackView } from '../../assets/svg/feedback-view.svg';

// ToDo: why not pass the entire style or item object ?
export interface IProps {
    styleItemData: any;
    heightContent: any;
    handleViewDetail: any;
    handleClick: any;
    handleAddtobag: any;
    handleViewInfo: Function;
    handleSendMessageWA: (item, trackEventParams) => void;
    setTitle: Function;
    setLoadingReact?: Function;
    handleClickStylist: any;
    handleStyleStatus?: any;
    handleClickStyle: any;
    isItemOnly?: boolean;
    handleViewFeedbacks?: MouseEventHandler<HTMLDivElement>;
}
function MyStyleItem({
    styleItemData,
    heightContent,
    handleViewDetail,
    handleClick,
    handleAddtobag,
    handleViewInfo,
    handleSendMessageWA,
    setTitle,
    handleClickStylist,
    handleStyleStatus,
    handleClickStyle,
    isItemOnly,
    handleViewFeedbacks,
}: IProps) {
    const style_name = styleItemData.title;
    const user = styleItemData.user;
    const [sharing, setSharing] = useState(false);
    const listItems = styleItemData.items;
    const imageJson = styleItemData.imageJson;
    const [list, setList] = useState(listItems);
    const classes = useStyles();
    const collection = styleItemData.collection;
    const id = styleItemData.id;
    const [activeItem, setActiveItem] = useState(0);
    const [reaction, setReaction] = useState({ totalLike: 0, totalDislike: 0 });
    const taffiId: string = styleItemData.taffiId;
    const userData = useSelector((state: RootState) => state.userDetail.me);
    const [isEditable, setIsEditable] = useState<boolean>(true);
    const storeSourceUrl = useSelector((state: RootState) => state.widget?.sourceUrl);
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: 'Yes',
        onFirstButtonClick: () => {},
        button2: '',
        path: '',
        type: '',
        buttonCancel: 'No',
        closeButton: false,
    });

    const handleViewImage = (image) => {
        handleClick(image);
    };

    // Setup title width
    const screenWidth = useVisualViewport();
    const [widthTitle, setWidthTitle] = useState(0);
    useEffect(() => {
        const temp = document.getElementById('header')?.offsetWidth;
        if (getActiveItem(list, activeItem)?.collection && temp) {
            setWidthTitle(temp);
        } else {
            const priceWidth = document.getElementById('price')?.offsetWidth;
            if (temp && priceWidth) {
                setWidthTitle(temp - priceWidth);
            }
        }
    }, [activeItem, list, screenWidth.viewport.width]);

    // Get Share Image
    const [shareImage, setShareImage] = useState<File | null>(null);
    const [gettingShareImage, setGettingShareImage] = useState(false);

    const getShareImage = async () => {
        try {
            setGettingShareImage(true);
            const imageFile = await fetchImageForShare(list[activeItem]?.data?.images[0]);
            setShareImage(imageFile as File);
        } catch (error) {
            console.error(error);
        } finally {
            setGettingShareImage(false);
        }
    };
    const getActiveItem = (listItems: any[], activeItem: any): any => {
        return listItems[activeItem];
    };

    const getActiveItemIndex = () => {
        return isItemOnly ? 1 : activeItem;
    };

    const url = useMemo(() => {
        if ((utils.isAppInWidgetMode() && storeSourceUrl?.length > 0) || !utils.isAppInWidgetMode()) {
            return getActiveItemIndex() && isItemOnly
                ? utils.getShareEntityUrl('/item', taffiId)
                : getActiveItemIndex() && getActiveItem(list, activeItem)
                    ? utils.getShareEntityUrlWithParams(
                        '/item',
                        getActiveItem(list, activeItem)?.data.taffiId,
                        `styleTaffiId=${taffiId}`,
                        taffiId,
                    )
                    : utils.getShareEntityUrl('/style', taffiId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isItemOnly, storeSourceUrl, taffiId, activeItem, list]);

    const shareStyle = async () => {
        const title = !getActiveItemIndex()
            ? `Taffi Style: ${style_name}`
            : `Taffi Item: ${list[activeItem]?.data?.title}`;
        const url = utils.getShareEntityUrl('/style', taffiId);
        if (!!navigator?.share) {
            await nativeImageShare({
                text: title + '\n\n' + createShareMessage(),
                url: url,
                image: shareImage!,
                title: title,
            });
        }
    };

    const createShareMessage = () => {
        const label = !getActiveItemIndex() ? 'style' : 'item';
        let message = `Hey,\n\nCheck out this cool ${label} on Taffi: ${url} ${
            userData ? `\n\n- ${userData?.firstName} ${userData?.lastName}` : ''
        }`;
        return message;
    };

    const onSetActiveItem = (activeItem: number) => {
        return setActiveItem(activeItem);
    };

    useEffect(() => {
        setList(utils.generateListItem(listItems, id, imageJson, isItemOnly, collection, styleItemData));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listItems]);

    useEffect(() => {
        if (
            activeItem !== 0 &&
            styleItemData?.items[activeItem - 1]?.data?.creator !== userData?.id &&
            !styleItemData?.items[activeItem - 1]?.data?.storeId
        ) {
            setIsEditable(false);
        } else {
            setIsEditable(true);
        }
    }, [activeItem, styleItemData, userData]);

    const history = useHistory();
    const [isShowMultiple, setIsShowMultiple] = useState(false);
    const handleMultiImage = () => {
        setIsShowMultiple(!isShowMultiple);
    };
    const handleSelectImg = (idx) => {
        const dataTemp = [...list];
        setList(
            dataTemp.map((item) => {
                if (item.id === getActiveItem(list, activeItem).id) {
                    return {
                        ...item,
                        indexSelect: idx,
                    };
                } else {
                    return { ...item };
                }
            }),
        );
    };

    const itemVariable = {
        // ToDo: why collection field is missing from the list.collection ?
        collectionName: list[activeItem]?.collection || 'items',
        docId: list[activeItem]?.id,
    };

    useEffect(() => {
        if (!itemVariable.docId) {
            trackEvent(TRACK_EVENT.BUSINESS_ERROR, {
                itemVariable,
                list: (list || []).map((l: any) => l.id),
                activeItem,
                style_name,
                styleItemDataId: styleItemData.id,
                taffiId,
                collection,
            });
        }
        // eslint-disable-next-line
    }, [itemVariable.docId]);

    useQuery(GET_REACTION_INFORMATION, {
        variables: { ...itemVariable },
        onCompleted: (data) => {
            if (data?.getReactionInformation?.reactionState) {
                const { totalLike, totalDislike } = data.getReactionInformation.reactionNumber;
                setReaction({
                    totalLike,
                    totalDislike,
                });
            }
        },
        fetchPolicy: 'cache-and-network',
        skip: !itemVariable.docId,
    });

    if (list.length <= 0) {
        return null;
    }

    const generateSubTitleStyle = (styleData) => {
        switch (styleData?.status) {
        case ItemStatus.Draft:
            return '(In Draft)';
        case ItemStatus.Published:
            return '(Published)';
        case ItemStatus.PublishToUnlisted:
            return '(Unlisted)';
        case ItemStatus.PublishToConsumers:
            const firstConsumerName = styleData.consumers?.length
                ? `(${styleData.consumers[0]?.firstName + ' ' + styleData.consumers[0]?.lastName})`
                : '';
            return firstConsumerName;
        default:
            return '';
        }
    };

    const handleStylistFeedbackView = (activeItem) => {
        handleViewFeedbacks!(activeItem);
        trackEvent(TRACK_EVENT.FEEDBACK_VIEW, {
            targetInfo: {
                type: activeItem?.collection || 'items',
                ID: activeItem?.id,
                taffiID: activeItem?.data?.taffiId,
            },
            stylistInfo: {
                stylist_id: user?.id,
                stylist_email: user?.email,
            },
            userInfo: {
                userId: userData?.id,
                email: userData?.email,
                name: `${userData?.firstName} ${userData?.lastName}`,
                userType: userData?.userType,
            },
        });
    };

    return (
        <div
            style={{
                padding: '10px 10px',
                height: `${heightContent}px`,
            }}
        >
            <div className={classes.styleContainer}>
                <div className={classes.styleHeader} id="header">
                    <div className={classes.user} style={{ width: `${widthTitle}px` }}>
                        <div className={classes.avatar} style={{ width: 40 }}>
                            <img
                                src={getUserProfilePhoto(user)}
                                style={{ width: 40, height: 'auto', borderRadius: '50%' }}
                                alt="stylist avatar"
                                onClick={handleClickStylist}
                            />
                        </div>
                        <div className={classes.title} style={{ width: `${widthTitle - 48}px` }}>
                            <p className={classes.titleDetail}>
                                {getActiveItem(list, activeItem)?.collection
                                    ? style_name
                                    : getActiveItem(list, activeItem)?.data?.title}{' '}
                                {generateSubTitleStyle(styleItemData)}
                            </p>
                            <p
                                className={classes.titleDetail}
                                style={{ opacity: 0.5, wordWrap: 'break-word' }}
                                onClick={handleClickStylist}
                            >
                                {user?.firstName || ''} {user?.lastName || ''}
                            </p>
                        </div>
                    </div>
                    {!getActiveItem(list, activeItem)?.collection && (
                        <div style={{ width: 'auto', display: 'flex', justifyContent: 'flex-end' }} id="price">
                            <span className={classes.price}>
                                {utils.getPrice(
                                    styleItemUtils.getInfo(getActiveItem(list, activeItem), 'price')?.price as number,
                                    styleItemUtils.getInfo(getActiveItem(list, activeItem), 'currency')?.currency,
                                )}
                            </span>
                        </div>
                    )}
                </div>
                <div className={classes.styleContent}>
                    <div
                        style={{
                            height: `${heightContent - 201}px`,
                            position: 'relative',
                        }}
                    >
                        <FeedItem
                            inputSearch={''}
                            heightContent={heightContent - 201}
                            listItems={list}
                            setActiveItem={onSetActiveItem}
                            handleClick={handleViewImage}
                            itemIndex={null}
                            handleMultiImage={() => setIsShowMultiple(false)}
                        />
                        <div
                            className={classes.actions}
                            style={{
                                height: `${heightContent - 201}px`,
                                justifyContent: `${isShowMultiple ? 'flex-end' : 'center'}`,
                            }}
                        >
                            {!isShowMultiple ? (
                                <div
                                    style={{
                                        height: `${heightContent - 251}px`,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <span
                                        className={classes.actionsIcon}
                                        onClick={() => handleViewInfo(getActiveItem(list, activeItem))}
                                    >
                                        <InfoOutlinedIcon style={{ color: themes.palette.primary.main }} />
                                    </span>
                                    <span className="d-flex flex-column align-items-center">
                                        <div className={classes.actionsIcon}>
                                            <BtnLikeFill />
                                        </div>
                                        <div className={classes.actionStatistic}>{millify(reaction.totalLike)}</div>
                                    </span>
                                    <span className="d-flex flex-column align-items-center">
                                        <div className={classes.actionsIcon}>
                                            <DislikeFill style={{ width: 22 }} />
                                        </div>
                                        <div className={classes.actionStatistic}>{millify(reaction.totalDislike)}</div>
                                    </span>
                                    <span
                                        className={classes.actionsIcon}
                                        onClick={() => handleStylistFeedbackView(getActiveItem(list, activeItem))}
                                    >
                                        <FeedBackView style={{ width: 22 }} />
                                    </span>
                                    {url?.length && (
                                        <span
                                            onClick={() => {
                                                setSharing(true);
                                                getShareImage();
                                            }}
                                            className={classes.actionsIcon}
                                        >
                                            <BtnShare />
                                        </span>
                                    )}

                                    {styleItemData?.status &&
                                        styleItemData?.status !== ItemStatus.Draft &&
                                        !isItemOnly && (
                                        <span
                                            className={classes.actionsIcon}
                                            onClick={() => {
                                                setModalShow({
                                                    ...modalShow,
                                                    show: true,
                                                    onFirstButtonClick: () =>
                                                        handleStyleStatus(styleItemData, ItemStatus.Draft),
                                                    title:
                                                            styleItemData?.status === ItemStatus.Published ||
                                                            styleItemData?.status === ItemStatus.PublishToConsumers ||
                                                            styleItemData?.status === ItemStatus.PublishToUnlisted
                                                                ? 'Your style will now be unpublished from Taffi marketplace. Do you want to continue ?'
                                                                : 'Your style will now be published to Taffi marketplace. All likes/dislikes and feedbacks associated with this style will be lost. Do you want to continue ?',
                                                });
                                            }}
                                        >
                                            <DoneIcon
                                                style={{
                                                    fontSize: '18px',
                                                    color:
                                                            styleItemData.status === ItemStatus.Published ||
                                                            styleItemData?.status === ItemStatus.PublishToConsumers ||
                                                            styleItemData?.status === ItemStatus.PublishToUnlisted
                                                                ? '#1d474f'
                                                                : '#CCDADB',
                                                }}
                                            />
                                        </span>
                                    )}
                                </div>
                            ) : (
                                <div className={classes.multiple}>
                                    {getActiveItem(list, activeItem).data.images?.length > 0 &&
                                        getActiveItem(list, activeItem).data.images.map((item, index) => (
                                            <div key={index} className={classes.multipleItem}>
                                                <img
                                                    src={item}
                                                    style={{
                                                        width: 43,
                                                        height: 43,
                                                        borderRadius: '50%',
                                                        border: '1px solid #E8F0F1',
                                                    }}
                                                    alt="style"
                                                    onClick={() => handleSelectImg(index)}
                                                />
                                            </div>
                                        ))}
                                </div>
                            )}
                            {getActiveItem(list, activeItem)?.data.collection === 'items' &&
                                getActiveItem(list, activeItem)?.data?.images?.length > 1 &&
                                (isShowMultiple ? (
                                    <span className={classes.actionsIcon}>
                                        <Close onClick={() => handleMultiImage()} />
                                    </span>
                                ) : (
                                    <span
                                        className={classes.actionsIcon}
                                        style={{ padding: 0, border: '1px solid #373737', cursor: 'pointer' }}
                                    >
                                        <img
                                            src={
                                                getActiveItem(list, activeItem).data.images[
                                                    getActiveItem(list, activeItem).indexSelect
                                                ]
                                            }
                                            style={{
                                                width: 43,
                                                height: 43,
                                                borderRadius: '50%',
                                                border: '1px solid #E8F0F1',
                                            }}
                                            alt="style"
                                            onClick={() => handleMultiImage()}
                                        />
                                    </span>
                                ))}
                        </div>
                    </div>
                </div>
                <div className={classes.styleAction}>
                    <button
                        className={classes.editOrAddButton}
                        disabled={!isEditable}
                        // onClick={() => { getActiveItem(list, activeItem)?.collection === "styles" ? handleAddtobag(listItems) : handleAddtobag([getActiveItem(list, activeItem)]) }}
                        // onClick={() => handleClickStyle(styleItemData, activeItem === 0 ? null : getActiveItem(list, activeItem).id) }
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '15px 0',
                            color: 'white',
                            fontSize: 12,
                            fontWeight: '600',
                            fontFamily: 'PoppinsRegular',
                            background: themes.palette.primary.main,
                            border: 'none',
                            borderRadius: '29px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            if (isItemOnly) {
                                handleClickStyle(styleItemData, null);
                            } else if (!styleItemData?.imageJson) {
                                setModalShow({
                                    ...modalShow,
                                    button1: 'Okay',
                                    buttonCancel: '',
                                    show: true,
                                    title: STRINGS.CANNOT_EDIT_STYLE_ALERT_MESSAGE,
                                });
                            } else if (
                                styleItemData?.status === ItemStatus.Published ||
                                styleItemData?.status === ItemStatus.PublishToConsumers ||
                                styleItemData?.status === ItemStatus.PublishToUnlisted
                            ) {
                                setModalShow({
                                    ...modalShow,
                                    show: true,
                                    onFirstButtonClick: () => {
                                        handleStyleStatus(styleItemData, ItemStatus.Draft);
                                        handleClickStyle(
                                            styleItemData,
                                            activeItem === 0 ? null : getActiveItem(list, activeItem).id,
                                        );
                                    },
                                    title: renderTitleWarningEditStyle(
                                        styleItemData?.status,
                                        activeItem === 0 ? 'style' : 'item',
                                        styleItemData,
                                    ),
                                });
                            } else {
                                handleClickStyle(
                                    styleItemData,
                                    getActiveItemIndex() === 0 ? null : getActiveItem(list, activeItem).id,
                                );
                            }
                        }}
                    >
                        <EditStyle style={{ color: 'white', marginRight: 8 }} />
                        {getActiveItemIndex() === 0 ? STRINGS.EDIT_STYLE : STRINGS.EDIT_ITEM}
                    </button>
                </div>
            </div>
            <BottomShareModal
                text={createShareMessage()}
                subject={
                    !getActiveItemIndex()
                        ? `Taffi Style: ${style_name}`
                        : `Taffi Item: ${list[activeItem]?.data?.title}`
                }
                open={sharing}
                onClose={() => {
                    setSharing(false);
                    setShareImage(null);
                }}
                onMoreSelect={() => {
                    return shareStyle();
                }}
                link={url!}
                moreLoading={gettingShareImage}
            />
            <StandardPopup
                show={modalShow.show}
                onHide={() => setModalShow({ ...modalShow, show: false })}
                title={modalShow.title}
                content={modalShow.content}
                button1={modalShow.button1}
                buttonCancel={modalShow.buttonCancel}
                onFirstButtonClick={modalShow.onFirstButtonClick}
                onSecondButtonClick={() => {
                    if (modalShow.path) history.push(modalShow.path);
                }}
                type={modalShow.type as any}
                closeButton={modalShow.closeButton}
            />
        </div>
    );
}

export default MyStyleItem;
